export enum AuditRecordTypes {
  GET_AUDIT_RECORD = '@auditRecord/GET_AUDIT_RECORD',
  GET_AUDIT_RECORD_SUCCESS = '@auditRecord/GET_AUDIT_RECORD_SUCCESS',
  GET_AUDIT_RECORD_FAIL = '@auditRecord/GET_AUDIT_RECORD_FAIL',
}
